const initialState = {
    map: [],
    open_mini_map: false,
};
export function miniMapReducer(state = initialState, action) {
    switch (action.type) {
        case 'CLOSE_MINI_MAP':
            return {
                ...state,
                map: state.map.filter((el) => el.device_id !== action.device_id),
            };
        case 'OPEN_MINI_MAP':
            if (state.map.some((map) => map.device_id == action.device_id))
                return { map: state.map, open_mini_map: true };
            return {
                ...state,
                map: [...state.map, { device_id: action.device_id }],
            };
        case 'CLOSE_ABOUT_MINI_MAP':
            return { map: state.map, open_mini_map: false };
        default:
            return state;
    }
}
